<template>
  <section
    class="page-vc"
    :class="[hasNewsletterForm && 'page-vc--has-newsletter-form', figureHidden && 'page-vc--figure-hidden']"
  >
    <div class="page-vc__fake-corners"></div>
    <slot></slot>
    <div class="page-vc__figure-container">
      <HUIBurgerFigure class="page-vc__figure-container-figure" random></HUIBurgerFigure>
      <form
        v-if="hasNewsletterForm"
        class="page-vc__newsletter-form"
        @submit.prevent="handleNewsletterFormSubmit"
      >
        <div class="a-container">
          <h2>
            <template v-if="submitted">Tak for din tilmelding</template>
            <template v-else>Modtag vores nyhedsbrev</template>
          </h2>
          <div class="page-vc__button-group a-button-group">
            <HUITextInput
              class
              required
              :disabled="submitting || submitted"
              type="email"
              :placeholder="submitted ? submittedEmail : 'Din e-mailadresse'"
              name="email"
              v-model="email"
            />
            <HUIButton
              class
              :spinner="submitting"
              :disabled="email.length === 0 || submitted || submitting"
              theme="blue"
              type="submit"
            >Send</HUIButton>
          </div>
          <p>
            <template
              v-if="submitted"
            >Du kan altid afmelde igen ved at klikke på afmeld-linket nederst i mailen.</template>
            <template v-else>Med info om gode tilbud, nyheder & anden go' burger-lovin'.</template>
          </p>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { HUIBurgerFigure, HUITextInput, HUIButton } from '@/halifax-ui'

export default {
  components: {
    HUIBurgerFigure,
    HUITextInput,
    HUIButton
  },
  props: {
    hasNewsletterForm: Boolean,
    figureHidden: Boolean
  },
  data() {
    return {
      email: '',
      submittedEmail: null,
      submitting: false,
      submitted: false
    }
  },
  methods: {
    async handleNewsletterFormSubmit() {
      try {
        this.submitting = true
        await this.$store.dispatch('user/CREATE_NEWSLETTER_SIGNUP', this.email)
        this.submittedEmail = this.email
        this.submitted = true
        this.email = ''
        this.$store.dispatch('dialog/ALERT', {
          props: {
            heading: 'Tak for din tilmelding',
            body: 'Du kan altid afmelde igen ved at klikke på afmeld-linket nederst i mailen.'
          }
        })
      } catch (error) {
        this.$store.dispatch('toast/ERROR', error.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.page-vc {
  $module: '.page-vc';

  $height-newsletter-form: 211px;

  background-color: $background-color;
  width: 100%;
  min-height: 100vh;
  min-height: var(--windowInnerHeight, 100vh);
  padding-bottom: $height-tabbar + $padding-bottom-page-vc;

  @include supports-safe-area-insets {
    padding-bottom: calc(
      var(--safe-area-inset-bottom) + #{$height-tabbar + $padding-bottom-page-vc}
    );
  }
  .window--framed & {
    padding-bottom: $padding-bottom-page-vc;

    @include supports-safe-area-insets {
      padding-bottom: calc(var(--safe-area-inset-bottom) + #{$padding-bottom-page-vc});
    }
  }
  &--figure-hidden {
    padding-bottom: $height-tabbar + $padding-bottom-page-vc - $height-footer-burger-figure;

    @include supports-safe-area-insets {
      padding-bottom: calc(
        var(--safe-area-inset-bottom) + #{$height-tabbar + $padding-bottom-page-vc -
          $height-footer-burger-figure}
      );
    }
    .window--framed & {
      padding-bottom: $padding-bottom-page-vc - $height-footer-burger-figure;

      @include supports-safe-area-insets {
        padding-bottom: calc(
          var(--safe-area-inset-bottom) + #{$padding-bottom-page-vc - $height-footer-burger-figure}
        );
      }
    }
  }
  &--has-newsletter-form {
    padding-bottom: $height-tabbar + $padding-bottom-page-vc + $height-newsletter-form;

    @include supports-safe-area-insets {
      padding-bottom: calc(
        var(--safe-area-inset-bottom) + #{$height-tabbar + $padding-bottom-page-vc +
          $height-newsletter-form}
      );
    }
  }
  &--has-newsletter-form {
    @at-root {
      &#{$module}--figure-hidden {
        padding-bottom: $height-tabbar + $padding-bottom-page-vc + $height-newsletter-form -
          $height-footer-burger-figure;

        @include supports-safe-area-insets {
          padding-bottom: calc(
            var(--safe-area-inset-bottom) + #{$height-tabbar + $padding-bottom-page-vc +
              $height-newsletter-form - $height-footer-burger-figure}
          );
        }
        .window-framed & {
          #{$module}--figure-hidden & {
            padding-bottom: $padding-bottom-page-vc + $height-newsletter-form -
              $height-footer-burger-figure;

            @include supports-safe-area-insets {
              padding-bottom: calc(
                var(--safe-area-inset-bottom) + #{$padding-bottom-page-vc + $height-newsletter-form -
                  $height-footer-burger-figure}
              );
            }
          }
        }
      }
    }
  }
  &::before {
    content: '';
    display: block;
    height: $height-navbar;
    width: 100%;
    background-color: $background-dark;
    margin-bottom: $padding-top-page-vc;

    @include supports-safe-area-insets {
      height: calc(var(--safe-area-inset-top) + #{$height-navbar});
    }
    .window--framed & {
      height: 1px !important;
      opacity: 0;
    }
  }
  &__newsletter-form {
    background-color: $background-color-tabbar;
    color: $background-light-50;
    padding-top: 30px;
    padding-bottom: 25px;
    text-align: center;

    .a-container {
      max-width: 500px;
    }

    h2 {
      margin-bottom: 15px;
    }
    p {
      margin-top: 15px;
      opacity: 0.75;
      font-size: 1.4rem;
      color: $halifax-light-brown;
    }
  }
  &__figure-container {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;

    &-figure {
      height: $height-footer-burger-figure;
      width: 100%;
      pointer-events: none;

      #{$module}--figure-hidden & {
        display: none;
      }

      img {
        margin: 0 !important;
      }
    }
    &::after {
      content: '';
      display: block;
      background: $background-color-tabbar;
      height: $height-tabbar;

      @include supports-safe-area-insets {
        height: calc(var(--safe-area-inset-bottom) + #{$height-tabbar});
      }
    }
    .window--framed &::after {
      height: 0px;
    }
  }
  &__button-group {
    .hui-text-input {
      width: 100%;
    }
    .hui-button {
      width: auto;
    }
  }
  &__fake-corners {
    $fake-corner-size: 4px;

    height: 0;
    width: $navbar-large-logo-size + $fake-corner-size * 2;
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;

    &::before,
    &::after {
      content: '';
      margin-top: -($padding-top-page-vc + $fake-corner-size);
      width: $fake-corner-size;
      height: $fake-corner-size;
    }
    &::before {
      background: radial-gradient(
          circle at 0 0,
          rgba(204, 0, 0, 0) $fake-corner-size,
          $background-color $fake-corner-size
        )
        top left;
    }
    &::after {
      right: 0;
      background: radial-gradient(
          circle at 100% 0,
          rgba(204, 0, 0, 0) $fake-corner-size,
          $background-color $fake-corner-size
        )
        top right;
    }
  }
}
</style>
